import { Component } from "@angular/core";

@Component({
  selector: "app-social-media",
  templateUrl: "./social-media.component.html",
})
export class SocialMediaComponent {}
